/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPointsMesuresByEquipement } from '../fn/point-mesure-controller/get-points-mesures-by-equipement';
import { GetPointsMesuresByEquipement$Params } from '../fn/point-mesure-controller/get-points-mesures-by-equipement';
import { PointMesureDto } from '../models/point-mesure-dto';

@Injectable({ providedIn: 'root' })
export class PointMesureControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPointsMesuresByEquipement()` */
  static readonly GetPointsMesuresByEquipementPath = '/v1/points-mesures/byEquipement/{idEquipement}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPointsMesuresByEquipement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPointsMesuresByEquipement$Response(
    params: GetPointsMesuresByEquipement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PointMesureDto>>> {
    return getPointsMesuresByEquipement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPointsMesuresByEquipement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPointsMesuresByEquipement(
    params: GetPointsMesuresByEquipement$Params,
    context?: HttpContext
  ): Observable<Array<PointMesureDto>> {
    return this.getPointsMesuresByEquipement$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PointMesureDto>>): Array<PointMesureDto> => r.body)
    );
  }
}
